import React from 'react';
import OrdersTable from 'components/Table/Orders';
import { ordersModelXmlNfeSlider } from 'components/Table/Orders/models';
import { Column } from 'components/Layout/Grid';

const XmlNfeSlider: React.FC = () => (
  <>
    <Column className="w-100 max-w-lg-100 flex-1 px-0">
      <OrdersTable
        trackingKey="XML NFe"
        tableSearchClassName=" "
        tabFilter={{ billingDate: { ne: null } }}
        model={ordersModelXmlNfeSlider}
        pageSize={5}
        showButton={false}
        showFilter
        showTypeDateFilter
      />
    </Column>
  </>
);

export default XmlNfeSlider;
